import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../../rest-api.service';
import { BaseInventoryComponent } from '../base-inventory/base-inventory.component';

@Component({
  selector: 'app-original-inventory',
  templateUrl: './original-inventory.component.html',
  styleUrls: ['./original-inventory.component.css']
})
export class OriginalInventoryComponent extends BaseInventoryComponent implements OnInit {

  constructor(public restApi: RestApiService) {
    super(restApi);
    this.getInventoryEndpoint = restApi.getAvailableWorks;
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
